import React from 'react'
import ProdIOOExiViewRow from './ProdIOOExiViewRow'
import withView from '../../../../cmn/docAutomation/withView';
import SarasTrans from '../../../../../library/notifications/SarasTrans';
import { UiView, UiViewHeading, UiTitle, UiAction, UiViewContent } from "../../../../../library/layout/Index";

const ProdIOOExiView = (props) => {
    const { formObject, viewData } = props;

    return (
        <>
            <UiView>
                <UiViewHeading>
                    <UiTitle>
                        <span className="uiInline"><SarasTrans value = "Stock Actions"/></span>
                    </UiTitle>
                    <UiAction>
                    </UiAction>
                </UiViewHeading>
                <UiViewContent>
                    <ul className="uiListTable uiProductionTable uiRawDataView" style={{ minWidth: "790px" }}>
                        <li className="uiSearchHeading">
                            <ul>
                                <li className="uiColumnLeft uiColumn130"><SarasTrans value="Item Id" /></li>
                                <li className="uiColumnLeft uiColumn350"><SarasTrans value="Item" /></li>
                                <li className="uiColumnLeft uiColumn50"><SarasTrans value="Unit" /></li>
                                <li className="uiColumnRight uiColumnQty"><SarasTrans value="Required" /></li>
                                <li className="uiColumnRight uiColumnQty"><SarasTrans value="Allocated" /></li>
                                <li className="uiColumnCenter uiColumn70"><SarasTrans value="Action" /> </li>
                            </ul>
                        </li>
                        {
                            Object.values(viewData ? viewData : {}).map((row, index) => (
                                <li><ProdIOOExiViewRow formObject={formObject} rowKey={row.rowKey} viewData={row} key={index} index={index + 1}/></li>
                            ))
                        }
                    </ul>
                </UiViewContent>
            </UiView>
        </>
    )
}

export default withView(ProdIOOExiView, "prodIOPlan", "prodIOPlan,prodIOSum");
